import React from 'react';
import './Footer.css';
import { motion } from '../utils/motion';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer__divider" />
            <div className="container">
                <div className="footer__content">
                    {/* Brand Column */}
                    <div className="footer__brand">
                        <div className="footer__logo">
                            <svg width="30" height="30" viewBox="0 0 28 28" fill="none">
                                <rect width="28" height="28" rx="8" fill="url(#footerGrad)" />
                                <path d="M8 10L14 18L20 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                <defs>
                                    <linearGradient id="footerGrad" x1="0" y1="0" x2="28" y2="28">
                                        <stop stopColor="#6c5ce7" />
                                        <stop offset="0.5" stopColor="#00cec9" />
                                        <stop offset="1" stopColor="#fd79a8" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <span className="footer__logo-text">
                                Life Be <span className="gradient-text">Like</span>
                            </span>
                        </div>
                        <p className="footer__tagline">
                            Creating groundbreaking AI digital content that captivates audiences across social platforms worldwide.
                        </p>
                    </div>

                    {/* Links */}
                    <div className="footer__links-group">
                        <h4 className="footer__links-title">Navigation</h4>
                        <ul className="footer__links">
                            <li><a href="#home">Home</a></li>
                            <li><a href="#about">About Studio</a></li>
                            <li><a href="#services">Our Services</a></li>
                            <li><a href="#connect">Connect</a></li>
                        </ul>
                    </div>

                    <div className="footer__links-group">
                        <h4 className="footer__links-title">Specialities</h4>
                        <ul className="footer__links">
                            <li><a href="#services">AI Video Creation</a></li>
                            <li><a href="#services">Viral Memes</a></li>
                            <li><a href="#services">Content Design</a></li>
                            <li><a href="#services">Shorts & Reels</a></li>
                        </ul>
                    </div>

                    <div className="footer__links-group">
                        <h4 className="footer__links-title">Social</h4>
                        <ul className="footer__links">
                            <li>
                                <a href="https://www.facebook.com/share/19i2p1Ab8M/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                                    Facebook
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UCMX4ihrgy1w84UTCzJ93jng" target="_blank" rel="noopener noreferrer">
                                    YouTube
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p className="footer__copyright">
                        &copy; {currentYear} <strong>Life Be Like Studio</strong>. All rights reserved.
                    </p>
                    <p className="footer__credit">
                        Built with <motion.span animate={{ scale: [1, 1.25, 1] }} transition={{ repeat: Infinity, duration: 1.5 }} className="footer__heart">&#9829;</motion.span> for creators
                    </p>
                    <p className="footer__developer">
                        Developed By{' '}
                        <a href="https://ceylon-code.ushanmihiranga.com/" target="_blank" rel="noopener noreferrer">
                            CeylonCode Team
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
